const StringToNumber = (string) => {
  return parseFloat(string) * 100;
};

export default StringToNumber;
